"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgBtCrown = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgBtCrown = function SvgBtCrown(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none"
  }, props), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#svg-bt-crown__clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.874 12.716l.025.03.034-.017 3.634-1.77a.614.614 0 01.668.086l.032-.038-.032.038c.185.158.26.412.188.645L19.9 19.991l.048.015-.048-.015a.614.614 0 01-.587.436H8.687a.614.614 0 01-.587-.436l-2.523-8.3a.614.614 0 01.856-.731s0 0 0 0l3.634 1.769.034.016.025-.029 3.41-3.93a.614.614 0 01.928 0l.038-.034-.038.033 3.41 3.931zm.946 6.482h.037l.011-.035 1.938-6.373.033-.11-.103.05-2.724 1.326a.614.614 0 01-.732-.15l-.038.033.038-.033-3.242-3.738-.038-.043-.038.043-3.242 3.738a.614.614 0 01-.733.15s0 0 0 0L7.264 12.73l-.103-.05.033.11 1.938 6.373.01.035h9.678z",
    fill: "currentColor",
    stroke: "#fff",
    strokeWidth: 0.1
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "svg-bt-crown__clip0"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#fff",
    d: "M5.5 6h17v17h-17z"
  }))));
};

exports.SvgBtCrown = SvgBtCrown;